import React from 'react';
import { Button, ConfigProvider, Spin } from 'antd';
import { DeleteOutlined, FileOutlined } from '@ant-design/icons';

interface FilePreviewProps {
  fileInfo: {
    name: string;
    size: string;
    type: string;
  };
  isUploading: boolean;
  onRemove: () => void;
}

interface ImagePreviewProps {
  imageUrl: string;
  isUploading: boolean;
  onRemove: () => void;
}

export const FilePreview: React.FC<FilePreviewProps> = ({ fileInfo, isUploading, onRemove }) => (
  <div className="file-preview" style={{
    padding: '10px',
    border: '1px solid #ddd',
    borderRadius: '8px',
    marginBottom: '10px',
    backgroundColor: '#f9f9f9',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  }}>
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <FileOutlined style={{ fontSize: '20px', marginRight: '10px', color: '#1890ff' }} />
      <div>
        <div style={{ fontWeight: 'bold', color: '#333' }}>{fileInfo.name}</div>
        <div style={{ fontSize: '12px', color: '#666' }}>
          {fileInfo.type} • {fileInfo.size}
        </div>
      </div>
    </div>
    <Button 
      type="text" 
      icon={<DeleteOutlined />}
      onClick={onRemove}
      size="small"
      danger
    />
    {isUploading && (
      <div className="file-upload-progress" style={{ marginLeft: '10px' }}>
        <Spin size="small" /> 
        <span style={{ marginLeft: '8px' }}>Uploading...</span>
      </div>
    )}
  </div>
);

export const ImagePreview: React.FC<ImagePreviewProps> = ({ imageUrl, isUploading, onRemove }) => (
  <div className="image-preview">
    <img
      src={imageUrl}
      alt="Preview"
      className="image-preview-thumbnail"
    />
    <button onClick={onRemove} className="remove-image-button-corner">
      x
    </button>
    {isUploading && (
      <div className="image-upload-progress">
        <ConfigProvider
          theme={{
            token: {
              colorPrimary: '#1890ff',
            },
          }}
        >
          <Spin size="small" /> 
          <span style={{ marginLeft: '8px' }}>Uploading image...</span>
        </ConfigProvider>
      </div>
    )}
  </div>
);
